import type { TextTrackDescription } from "react-native-theoplayer";

import type { PlaybackTrackDto } from "$src/core/models/dto";

const resolveTrackSrc = (track: PlaybackTrackDto) =>
  track.uri || track.url || "";

/**
 * Maps API playback tracks of type "thumbnails" to THEOplayer sideloaded
 * text tracks used for seek preview images.
 */
const mapPlaybackThumbnailTracks = (
  tracks: PlaybackTrackDto[] | undefined,
): TextTrackDescription[] | undefined => {
  if (!tracks?.length) {
    return undefined;
  }

  const thumbnailTracks = tracks
    .filter((track) => track.type === "thumbnails")
    .map(resolveTrackSrc)
    .filter((src): src is string => !!src)
    .map(
      (src, index): TextTrackDescription => ({
        default: index === 0,
        src,
        label: "thumbnails",
        kind: "metadata",
        format: "webvtt",
        // Placeholder only — irrelevant for thumbnail metadata tracks today.
        // Wire from API language when the backend exposes it (e.g. for captions).
        srclang: "en",
      }),
    );

  return thumbnailTracks.length > 0 ? thumbnailTracks : undefined;
};

export default mapPlaybackThumbnailTracks;
